import { render, staticRenderFns } from "./SortableTableHeader.vue?vue&type=template&id=16887390&scoped=true&"
import script from "./SortableTableHeader.vue?vue&type=script&lang=js&"
export * from "./SortableTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./SortableTableHeader.vue?vue&type=style&index=0&id=16887390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16887390",
  null
  
)

export default component.exports